/* GT PDP — site-wide helpers that CSS alone cannot do.
   1) Giftnote renders its "Sending as a gift?" button inside an open shadow root
      with its own hard-coded styles, so we append a matching stylesheet into that
      shadow root whenever the element appears (the basket drawer re-renders it).
   2) Rebuy basket drawer: Shopify applies either a discount code or the free gift
      (Rebuy widget 198258), whichever saves more. When the code wins, the gift
      silently goes back to full price, so we remove it, hide the gift picker and
      say why. When the gift wins, Rebuy calls the code "not valid", so we replace
      that with a message explaining the gift is worth more. */
(function () {
  var css = [
    '#container{width:100%;display:flex;align-items:center;justify-content:center}',
    '#button{width:100%;height:40px;box-sizing:border-box;border-radius:99px;border:1.5px solid #51593d;background:transparent;color:#51593d;',
    'font-family:"DM Sans",Assistant,sans-serif;font-size:12px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;line-height:1;cursor:pointer;transition:background .15s ease,color .15s ease}',
    '#button:hover{background:#51593d;color:#f9f4ea}',
    '#button .hidden{display:none}'
  ].join('');

  function skin(el) {
    var root = el.shadowRoot;
    if (!root) { setTimeout(function () { skin(el); }, 300); return; }
    if (root.querySelector('style[data-gt-pdp]')) return;
    var s = document.createElement('style');
    s.setAttribute('data-gt-pdp', '');
    s.textContent = css;
    root.appendChild(s);
  }
  function scan() { document.querySelectorAll('giftnote-button').forEach(skin); }

  scan();
  if (window.MutationObserver) {
    new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

(function () {
  var GIFT_WIDGET_ID = '198258';
  var STORAGE_KEY = 'gt-gift-replaced-by-code';
  var NOTICE_CLASS = 'gt-gift-code-notice';
  var BLOCKED_CLASS = 'gt-gift-blocked-by-code';
  var CONFLICT_MESSAGE = 'This code can’t be combined with your free gift, which is worth more.';
  var checking = false;
  var queued = false;
  var conflictCode = null;

  function readState() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY)); } catch (e) { return null; }
  }
  function writeState(state) {
    try {
      if (state) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  function isGift(item) {
    return !!item.properties && String(item.properties._widget_id) === GIFT_WIDGET_ID;
  }
  function codesByApplicable(cart, applicable) {
    return (cart.discount_codes || [])
      .filter(function (code) { return code.applicable === applicable; })
      .map(function (code) { return code.code.toUpperCase(); });
  }

  // Rebuy.Cart.removeItem keeps the drawer in sync; the timeout stops a callback
  // that never fires from blocking later checks.
  function removeItem(item) {
    return new Promise(function (resolve) {
      var timer = setTimeout(resolve, 6000);
      window.Rebuy.Cart.removeItem(item, function () { clearTimeout(timer); resolve(); });
    });
  }
  function removeItems(items) {
    return items.reduce(function (chain, item) {
      return chain.then(function () { return removeItem(item); });
    }, Promise.resolve());
  }

  // Would this code apply if the gift weren't in the basket? Anything that can't be
  // confirmed from the storefront (customer-specific or collection codes) keeps
  // Rebuy's own message.
  function isEligible(discount, cart) {
    if (!discount || discount.status !== 'ACTIVE') return false;
    var now = Date.now();
    if (discount.starts_at && now < new Date(discount.starts_at).getTime()) return false;
    if (discount.ends_at && now > new Date(discount.ends_at).getTime()) return false;
    if (discount.usage_limit != null && discount.usage_count >= discount.usage_limit) return false;
    if (discount.customer_selection !== 'all' || discount.target_selection !== 'all') return false;
    var range = discount.prerequisite_subtotal_range;
    var minimum = range ? parseFloat(range.greater_than_or_equal_to) * 100 : 0;
    return cart.items_subtotal_price >= minimum;
  }

  function findConflict(cart) {
    var discount = window.Rebuy.SmartCart && window.Rebuy.SmartCart.storefrontDiscount;
    var blocked = codesByApplicable(cart, false);
    var hasFreeGift = cart.items.some(function (item) { return isGift(item) && item.final_line_price === 0; });
    if (!discount || !blocked.length || !hasFreeGift) return Promise.resolve(null);
    return Promise.resolve(discount.fetchDiscountCached(blocked[0])).then(function (details) {
      return isEligible(details, cart) ? blocked[0] : null;
    });
  }

  function showConflictMessage() {
    var smartCart = window.Rebuy.SmartCart;
    var discount = smartCart && smartCart.storefrontDiscount;
    if (!discount || discount.errorMessage() === CONFLICT_MESSAGE) return;
    discount.setError(CONFLICT_MESSAGE);
    if (smartCart.view) smartCart.view.$forceUpdate();
  }

  function render(state) {
    document.documentElement.classList.toggle(BLOCKED_CLASS, !!state);
    var notice = document.querySelector('.' + NOTICE_CLASS);
    if (!state) { if (notice) notice.remove(); return; }

    var anchor = document.querySelector('#rebuy-cart [data-rebuy-component="discount-input"]');
    if (!anchor) return;
    if (!notice) {
      notice = document.createElement('p');
      notice.className = NOTICE_CLASS;
      notice.setAttribute('role', 'status');
    }
    notice.textContent = 'Your code ' + state.code + ' saves you more than your free gift, so we’ve removed ' +
      state.gift + ' from your basket. Discount codes can’t be combined with other offers.';
    if (anchor.nextElementSibling !== notice) anchor.insertAdjacentElement('afterend', notice);
  }

  function check() {
    if (!window.Rebuy || !window.Rebuy.Cart) return;
    if (checking) { queued = true; return; }
    checking = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var state = readState();
        var applied = codesByApplicable(cart, true);
        // A gift that is no longer free means Shopify chose the code over it
        var paidGifts = cart.items.filter(function (item) { return isGift(item) && item.final_line_price > 0; });

        if (applied.length && paidGifts.length) {
          state = { code: applied[0], gift: paidGifts[0].product_title };
          writeState(state);
          return removeItems(paidGifts).then(function () { return { state: state, conflict: null }; });
        }
        if (state && applied.indexOf(state.code) === -1) {
          state = null;
          writeState(null);
        }
        return findConflict(cart).then(function (code) { return { state: state, conflict: code }; });
      })
      .then(function (result) {
        conflictCode = result.conflict;
        if (conflictCode) showConflictMessage();
        render(result.state);
      })
      .catch(function (error) { console.error('[gt] gift/code check failed', error); })
      .then(function () {
        checking = false;
        if (queued) { queued = false; check(); }
      });
  }

  ['rebuy:cart.change', 'rebuy:discount.change', 'rebuy:smartcart.ready', 'rebuy:smartcart.show'].forEach(function (name) {
    document.addEventListener(name, check);
  });

  // Rebuy re-renders the drawer, which drops the notice and can put its own
  // "not a valid code" message back; restore ours
  if (window.MutationObserver) {
    new MutationObserver(function () {
      var state = readState();
      if (state && !document.querySelector('.' + NOTICE_CLASS)) render(state);
      var error = conflictCode && document.querySelector('#rebuy-cart .rebuy-cart__discount-error-message');
      if (error && error.textContent !== CONFLICT_MESSAGE) showConflictMessage();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  check();
})();

/* 3) Product card variant pills: products with many sizes (or colour + size
      combinations) stacked a tall column of pills under the title. Two moves
      keep the card short: drop any option segment shared by every pill
      ("14cm / Leaf Green" x5 becomes "14cm"), and fold anything past the
      fourth pill behind a "+N" pill that reveals the rest. Runs on cards
      rendered later too (tabbed collections, Globo, sliders). */
(function () {
  var MAX = 4;

  function compact(wrap) {
    if (wrap.getAttribute('data-gt-compact')) return;
    wrap.setAttribute('data-gt-compact', '1');
    var pills = Array.prototype.slice.call(wrap.querySelectorAll('.tc-card__variant-pill'));
    if (pills.length < 2) return;

    var parts = pills.map(function (p) { return p.textContent.trim().split(/\s*\/\s*/); });
    var segs = Math.min.apply(null, parts.map(function (a) { return a.length; }));
    if (segs > 1) {
      var keep = [];
      for (var i = 0; i < segs; i++) {
        var same = parts.every(function (a) { return a[i] === parts[0][i]; });
        if (!same) keep.push(i);
      }
      if (keep.length && keep.length < segs) {
        pills.forEach(function (p, k) {
          p.title = p.textContent.trim();
          p.textContent = keep.map(function (i) { return parts[k][i]; }).join(' / ');
        });
      }
    }

    var extra = pills.length - MAX;
    if (extra < 2) return;
    pills.slice(MAX).forEach(function (p) { p.hidden = true; });
    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'tc-card__variant-more';
    more.textContent = '+' + extra;
    more.setAttribute('aria-label', 'Show all ' + pills.length + ' options');
    more.addEventListener('click', function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      pills.forEach(function (p) { p.hidden = false; });
      more.remove();
    });
    wrap.appendChild(more);
  }

  function scan() { document.querySelectorAll('.tc-card__variants').forEach(compact); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  if (window.MutationObserver) {
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 80);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();

/* Sale price on product cards rendered by the filter app: its template still
   emits "£now <span compare>", so upgrade that in place to the theme's markup
   (price in clay, struck-through was-price, Save % chip). Runs on load and
   whenever the grid re-renders. */
(function () {
  function money(text) { return Math.round(parseFloat(String(text).replace(/[^0-9.]/g, '')) * 100) || 0; }
  function upgrade(priceEl) {
    if (priceEl.classList.contains('is-sale') || priceEl.querySelector('.tc-card__price-now')) return;
    var compare = priceEl.querySelector('.tc-card__price-compare');
    if (!compare) return;
    var nowText = '';
    Array.prototype.slice.call(priceEl.childNodes).forEach(function (n) {
      if (n.nodeType === 3) { nowText += n.textContent; priceEl.removeChild(n); }
    });
    nowText = nowText.replace(/\s+/g, ' ').trim();
    if (!nowText) return;
    var now = document.createElement('span');
    now.className = 'tc-card__price-now';
    now.textContent = nowText;
    priceEl.insertBefore(now, compare);
    var s = document.createElement('s');
    s.className = 'tc-card__price-compare';
    s.textContent = compare.textContent.trim();
    priceEl.replaceChild(s, compare);
    var wasP = money(s.textContent), nowP = money(nowText);
    if (wasP > nowP) {
      var saving = Math.floor((wasP - nowP) * 100 / wasP);
      if (saving >= 5) {
        var chip = document.createElement('span');
        chip.className = 'tc-card__price-save';
        chip.textContent = 'Save ' + saving + '%';
        priceEl.appendChild(chip);
      }
      priceEl.classList.add('is-sale');
    }
  }
  // A card with a Sale badge whose lead size is not the reduced one: switch to the first reduced size.
  function leadWithSale(card) {
    if (card.getAttribute('data-gt-salelead')) return;
    card.setAttribute('data-gt-salelead', '1');
    if (!card.querySelector('.tc-card__sale-badge') || card.querySelector('.tc-card__price.is-sale')) return;
    var pills = Array.prototype.slice.call(card.querySelectorAll('.tc-card__variant-pill'));
    for (var i = 0; i < pills.length; i++) {
      var p = parseInt(pills[i].getAttribute('data-price') || '0', 10), c = parseInt(pills[i].getAttribute('data-compare-price') || '0', 10);
      if (c > p) { pills[i].click(); break; }
    }
  }
  function scan() {
    document.querySelectorAll('.tc-card__price').forEach(upgrade);
    document.querySelectorAll('.tc-card').forEach(leadWithSale);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  if (window.MutationObserver) {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 80); }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
